import $ from 'jquery';

const header = () => {
    const header = $("header.wp-block-template-part");
    let lastScrollTop = 0;
    const delta = 10;
    const offsetLimit = 100;
    const body = $("body");

    $(document).on('click', '.hamburger-menu-wrapper', function (e) {
        header.toggleClass('is-open');
        body.toggleClass('menu-freeze');

    });


    $(document).on('click', 'header.wp-block-template-part .menu-item a', function () {
        header.removeClass('is-open');
        body.removeClass('menu-freeze');
    });

    function checkHeaderTop() {
         const currentScrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
        const topOffset = 30;

        if (currentScrollTop <= topOffset) {
            header.addClass('is-at-top');
        } else {
            header.removeClass('is-at-top');
        }
        return currentScrollTop;
    }

    function handleScroll() {
        const currentScrollTop = checkHeaderTop();

        if (Math.abs(currentScrollTop - lastScrollTop) <= delta) {
            return;
        }
        if (currentScrollTop > lastScrollTop && currentScrollTop > offsetLimit) {
            header.removeClass("visible");
            header.addClass("hidden");
        } else {
            header.removeClass("hidden");
            header.addClass("visible");
        }
        lastScrollTop = currentScrollTop;
    }

    function updateHeaderHeight() {
        if (header.length) {
            var headerHeight = header.outerHeight();
            $(':root').css('--header-height', headerHeight + 'px');
        }
    }

    window.addEventListener('resize', updateHeaderHeight);
    window.addEventListener('load', updateHeaderHeight);
      window.addEventListener('resize', checkHeaderTop);
    window.addEventListener('load', checkHeaderTop);


    window.removeEventListener("scroll", handleScroll);
    window.addEventListener("scroll", handleScroll);
    
};

export default header;
